import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Navigation from "./navigation";
import Footer from "./footer";

const NewsList = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await fetch(`${API_URL}/api/blogs/`);
      if (response.ok) {
        const data = await response.json();
        setBlogs(data);
      } else {
        setError('Failed to fetch blogs');
      }
    } catch (err) {
      setError('Network error while fetching blogs');
    } finally {
      setLoading(false);
    }
  };

  const formatBlogDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const filteredBlogs = blogs.filter(blog =>
    blog.title.toLowerCase().includes(search.toLowerCase()) ||
    (blog.category && blog.category.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className="">
      <div style={{ background: "black" }}>
          <div className="fixed top-0 left-0 right-0 z-50">
  <Navigation />
</div>
      </div>
      
      <div className="hero-section2 px-4 sm:px-6 md:px-8 lg:px-12">
        <div className="text-white text-center text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold py-8">
          News / Blogs
        </div>
      </div>

      <div className="max-width px-4 sm:px-6 md:px-8 lg:px-12">
        {/* Search Section (Commented out but made responsive) */}
        {/* <div className="events-filter-section mt-6 sm:mt-8 md:mt-10 mb-6 sm:mb-8 md:mb-10">
          <div className="filter-buttons flex justify-center">
            <input
              type="text"
              placeholder="Search blogs..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="input px-4 py-2 sm:px-5 sm:py-3 md:px-6 md:py-4 text-sm sm:text-base md:text-lg rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              style={{ minWidth: '250px', maxWidth: '400px', width: '100%' }}
            />
          </div>
        </div> */}

        {/* Loading State */}
        {loading ? (
          <div className="loading-container flex flex-col items-center justify-center py-12 sm:py-16 md:py-20">
            <div className="loading-spinner w-12 h-12 sm:w-16 sm:h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
            <p className="mt-4 text-base sm:text-lg md:text-xl text-gray-600">Loading news...</p>
          </div>
        ) : error ? (
          <div className="error-container flex flex-col items-center justify-center py-12 sm:py-16 md:py-20 text-center">
            <p className="text-base sm:text-lg md:text-xl text-red-500 mb-4">{error}</p>
            <button 
              onClick={fetchBlogs} 
              className="retry-btn px-6 py-3 sm:px-8 sm:py-4 bg-blue-600 text-white text-sm sm:text-base md:text-lg rounded-lg hover:bg-blue-700 transition-colors duration-300"
            >
              Try Again
            </button>
          </div>
        ) : (
          <div className="events-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            {filteredBlogs.length > 0 ? (
              filteredBlogs.map(blog => (
                <div 
                  key={blog.id} 
                  className="event-card blog-cards p-4 sm:p-5 md:p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 cursor-pointer flex flex-col h-full"
                  onClick={() => window.location.href = `/news/${blog.id}`}
                >
                  <img 
                    src={blog.thumbnail ? `${API_URL}${blog.thumbnail}` : 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg'} 
                    alt={blog.title} 
                    className="w-full h-48 sm:h-56 md:h-64 object-cover rounded-lg mb-4"
                  />
                  
                  <div className="flex flex-col justify-between flex-grow gap-4 sm:gap-5 md:gap-6">
                    <div className="text-xs sm:text-sm md:text-base text-gray-500">
                      {formatBlogDate(blog.created_at)}
                    </div>
                    
                    <div className="event-title text-lg sm:text-xl md:text-2xl font-bold text-gray-800 line-clamp-2">
                      {blog.title}
                    </div>
                    
                    <Link 
                      to={`/news/${blog.id}`} 
                      className="link-btn text-sm sm:text-base md:text-lg text-blue-600 font-medium hover:text-blue-800 hover:underline transition-colors duration-300 mt-auto"
                    >
                      Continue Reading →
                    </Link>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-events col-span-1 sm:col-span-2 lg:col-span-3 flex flex-col items-center justify-center py-12 sm:py-16 md:py-20 text-center">
                <p className="text-base sm:text-lg md:text-xl text-gray-600">
                  No news found {search ? 'for the current search' : 'at the moment'}.
                </p>
              </div>
            )}
          </div>
        )}
        
        <div className="section-margin"></div>
      </div>
      
      <div className="section-margin"></div>
      <div className="section-margin"></div>
      
      <Footer />
    </div>
  );
};

export default NewsList;